module.exports = __webpack_public_path__ + "img/linepay.94d3c3ea.png";